import { ReactElement } from "react"

export enum PROVIDERS {
	LOST = "LOST",
	MONTAG = "montag",
	DIENSTAG = "dienstag",
	MITTWOCH = "mittwoch",
	DONNERSTAG = "donnerstag",
	FREITAG = "freitag",
	SAMSTAG = "samstag",
	SONNTAG = "sonntag",
}

export interface WeekPlanProps {
	getDay: Number
	day: string
	provider: PROVIDERS
	cardHeadline: String
	shortTextHeadline?: String
	shortText: ReactElement
	text: ReactElement
}

export const WEEKPLAN: WeekPlanProps[] = [
	{
		getDay: 1,
		day: "Montag",
		provider: PROVIDERS.MONTAG,
		cardHeadline: "nimm2 Lachgummi Produktpaket",

		shortTextHeadline: "GEWINNE AN MONTAGEN",
		shortText: (
			<>
				An allen Montagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>110x Produktpaket von nimm2 Lachgummi</strong>
				</div>
			</>
		),
		text: <p className="font-Museo">Probiere unsere große nimm2 Lachgummi Vielfalt mit einem nimm2 Lachgummi Produktpaket bestehend aus 10 Packungen.</p>,
	},
	{
		getDay: 2,
		day: "Dienstag",
		provider: PROVIDERS.DIENSTAG,
		cardHeadline: "nimm2 Lachgummi Liegestuhl",
		shortTextHeadline: "GEWINNE AN DIENSTAGEN",
		shortText: (
			<>
				An allen Dienstagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>44x nimm2 Lachgummi Liegestuhl</strong> sowie nimm2 Lachgummi Frucht 250g und nimm2 Lachgummi Milchgeister 225g
				</div>
			</>
		),
		text: (
			<p className="font-Museo">
				Entspannung gefällig? Gewinne einen exklusiven nimm2 Lachgummi Liegestuhl! Dazu gibt es noch jeweils einen Beutel nimm2 Lachgummi Frucht 250g und nimm2 Lachgummi
				Milchgeister 225g.
			</p>
		),
	},
	{
		getDay: 3,
		day: "Mittwoch",
		provider: PROVIDERS.MITTWOCH,
		cardHeadline: "nimm2 Strandtasche & Beachball Set",
		shortTextHeadline: "GEWINNE AN MITTWOCHEN",
		shortText: (
			<>
				An allen Mittwochen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>99x nimm2 Sommer Hit Strandtasche</strong> und <strong>nimm2 soft Splash Beachballset</strong> sowie nimm2 Sommer Hit 300g und nimm2 soft Splash 240g
				</div>
			</>
		),
		text: (
			<p className="font-Museo">
				Aktiv im Park! Gewinne eins von 99 Sommerpaketen bestehend aus einer nimm2 Sommer Hit Strandtasche sowie einem nimm2 soft Splash Beachballset! Für den perfekten Tag im Park
				gibt es dazu passend noch jeweils einen Beutel nimm2 Sommer Hit 300g und nimm2 soft Splash 240g.
			</p>
		),
	},
	{
		getDay: 4,
		day: "Donnerstag",
		provider: PROVIDERS.DONNERSTAG,
		cardHeadline: "nimm2 Produktpaket",
		shortTextHeadline: "GEWINNE AN DONNERSTAGEN",
		shortText: (
			<>
				An allen Donnerstagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>110x Produktpaket von nimm2 und nimm2 Lachgummi</strong>
				</div>
			</>
		),
		text: <p className="font-Museo">Probiere unsere große nimm2 und nimm2 Lachgummi Vielfalt mit einem Produktpaket bestehend aus 10 Packungen.</p>,
	},
	{
		getDay: 5,
		day: "Freitag",
		provider: PROVIDERS.FREITAG,
		cardHeadline: "nimm2 Badespaß",
		shortTextHeadline: "GEWINNE AN FREITAGEN",
		shortText: (
			<>
				An allen Freitagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>44x nimm2 Lachgummi Apfellinge Luftmatratze sowie nimm2 Lachgummi Apfellinge 225g</strong>
				</div>
			</>
		),
		text: (
			<p className="font-Museo">
				Was darf an deinem Sommer-Sonne-Badetag nicht fehlen? Gewinne eine von 44 nimm2 Lachgummi Apfellinge Luftmatratzen! Ein Beutel nimm2 Lachgummi Apfellinge 225g ist ebenfalls
				dabei.
			</p>
		),
	},

	{
		getDay: 6,
		day: "Samstag",
		provider: PROVIDERS.SAMSTAG,
		cardHeadline: "nimm2 Picknickspaß",
		shortTextHeadline: "GEWINNE AN SAMSTAGEN",
		shortText: (
			<>
				An allen Samstagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>77x nimm2 Lachgummi Picknickdecke</strong> sowie tolle Naschpakete
				</div>
			</>
		),
		text: (
			<p className="font-Museo">
				Genieße dein Picknick in vollen Zügen! Gewinne eine von 77 nimm2 Lachgummi Picknickdecken und erhalte passend dazu die nimm2 Lachgummi-Sorten Frucht 250g, Sauer Stars 250g,
				Milchgeister 225g und Milchbubis 225g.
			</p>
		),
	},

	{
		getDay: 0,
		day: "Sonntag",
		provider: PROVIDERS.SONNTAG,
		cardHeadline: "Unterwegs mit Spaß im Gepäck",

		shortTextHeadline: "GEWINNE AN SONNTAGEN",
		shortText: (
			<>
				An allen Sonntagen im Aktionszeitraum verlosen wir insgesamt:
				<br />
				<br />
				<div>
					<strong>44x Koffer der Marke American Tourister inkl. nimm2 Bonbon Kofferanhänger sowie nimm2 Bonbon Orange Zitrone 240g und nimm2 soft Frucht 195g</strong>
				</div>
			</>
		),
		text: (
			<p className="font-Museo">
				Geh auf Reisen mit nimm2 und gewinne einen von insgesamt 44 Koffern der Marke American Tourister, Modell FastForward, 55cm in der Farbe Radiant Orange inkl. nimm2 Bonbon
				Kofferanhänger! Für die perfekte Verpflegung legen wir jeweils noch einen Beutel nimm2 Bonbon Orange Zitrone 240g und nimm2 soft Frucht 195g oben drauf.
			</p>
		),
	},
]

export const PRICE_TYPE: any = {
	"0": {
		provider: PROVIDERS.LOST,
		key: "PRIZE_BLANK",
	},
	"1": {
		provider: PROVIDERS.MONTAG,
		key: "77_Ravensburger_nimm2_Lachgummi_memory",
	},
	"2": {
		provider: PROVIDERS.DIENSTAG,
		key: "44_nimm2_Lachgummi_Liegestuhl",
	},
	"3": {
		provider: PROVIDERS.MITTWOCH,
		key: "77_nimm2_Strandtasche_und_Beachball Set",
	},
	"4": {
		provider: PROVIDERS.DONNERSTAG,
		key: "110_nimm2_product_package",
	},
	"5": {
		provider: PROVIDERS.FREITAG,
		key: "44_Koffer_American_Tourister",
	},
	"6": {
		provider: PROVIDERS.SAMSTAG,
		key: "44_nimm2_Luftmatratze_und_Badehandtuch",
	},
	"7": {
		provider: PROVIDERS.SONNTAG,
		key: "77_nimm2_Wikinger_Wurfspiel",
	},
}

export const STATUS_PROMO_SOON = "promotion.status.soon"
export const STATUS_PROMO_LIVE = "promotion.status.live"
export const STATUS_PROMO_OVER = "promotion.status.over"
